import styled from 'styled-components'
import { NavLink } from 'react-router-dom'

export const NFTCardView = styled.div`
  width: 250px;
  padding: 1rem;
  margin-bottom: 0.5rem;
  background: ${({ theme }) => theme.bg1};
  cursor: pointer;
  user-select: none;
`

export const NFTCardImage = styled.div`
  width: 100%;
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  min-height: 250px;

  .link {
    position: relative;
    display: flex;
    min-height: 240px;
    width: 100%;
  }

  .crypto-seal-bg {
    width: 100%;
  }

  .crypto-seal-character {
    position: absolute;
    width: 50%;
  }

  :hover {
    .image-overlay {
      opacity: 1;
    }
  }
`

export const NFTCardImageOverlay = styled.div`
  opacity: 0;
  transition: all ease-in 0.2s;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
`

export const NFTCardMeta = styled.div`
  width: 100%;
  font-size: 0.9rem;
`
export const NFTCardTitle = styled.div`
  width: 100%;
  margin-top: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  margin-bottom: 0.3rem;
`

export const NFTCardPrice = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

export const CardNavLink = styled(NavLink)`
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 1rem;
  width: fit-content;
  font-weight: 500;
`

export const CardImageNavLink = styled(NavLink)`
  cursor: pointer;
  text-decoration: none;
  color: ${({ theme }) => theme.text2};
  font-size: 1rem;
  width: fit-content;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;

  .default-image {
    img {
      max-width: 100%;
      max-height: 224px;
    }
  }
`
